export default __webpack_public_path__ + "static/media/checked-circle.f6694807.svg";